import { render } from "./OngStatus.vue?vue&type=template&id=022fbfa8"
import script from "./OngStatus.vue?vue&type=script&lang=js"
export * from "./OngStatus.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/transport/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__